import { type HTMLAttributes } from 'react'

import { badgeVariants, type BadgeVariantProps } from './badge.variants'
import { cn } from '@/lib/utils'

export interface BadgeProps extends HTMLAttributes<HTMLDivElement>, BadgeVariantProps {}

export function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant, size }), className)} {...props} />
  )
}
